import React from 'react';

export default function LandingFooter() {
  const year = new Date().getFullYear();

  const cols = [
    {
      title: 'Produto',
      links: ['Funcionalidades', 'Planos e Preços', 'API Docs', 'Changelog'],
    },
    {
      title: 'Integrações',
      links: ['Nuvemshop', 'Shopify', 'WooCommerce', 'API REST'],
    },
    {
      title: 'Transportadoras',
      links: ['Correios', 'Jadlog', 'Loggi', 'J&T Express'],
    },
    {
      title: 'Empresa',
      links: ['Sobre nós', 'Blog', 'Contato', 'Suporte'],
    },
  ];

  return (
    <footer style={styles.footer}>
      <div style={styles.inner}>
        <div style={styles.top}>
          <div style={styles.brand}>
            <div style={styles.logoWrap}>
              <span style={styles.logoIcon}>📦</span>
            </div>
            <div style={styles.logoText}>BringHub <strong>Frete</strong></div>
            <p style={styles.tagline}>
              A plataforma que conecta seu e-commerce a todas as transportadoras do Brasil.
            </p>
            <div style={styles.social}>
              {['Instagram', 'LinkedIn', 'GitHub'].map((s) => (
                <span key={s} style={styles.socialLink}>{s}</span>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title} style={styles.col}>
              <div style={styles.colTitle}>{col.title}</div>
              {col.links.map((link) => (
                <span key={link} style={styles.footerLink}>{link}</span>
              ))}
            </div>
          ))}
        </div>

        <div style={styles.bottom}>
          <span>© {year} BringHub Frete. Todos os direitos reservados.</span>
          <div style={styles.bottomLinks}>
            <span style={styles.bottomLink}>Termos de Uso</span>
            <span style={styles.bottomLink}>Política de Privacidade</span>
            <span style={styles.bottomLink}>LGPD</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    background: '#0f172a',
    color: '#94a3b8',
    padding: '64px 24px 32px',
  },
  inner: { maxWidth: '1200px', margin: '0 auto' },
  top: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
    gap: '40px',
    paddingBottom: '48px',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
  },
  brand: { display: 'flex', flexDirection: 'column', gap: '12px' },
  logoWrap: {
    width: '40px', height: '40px',
    background: 'rgba(255,255,255,0.08)',
    borderRadius: '10px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  logoIcon: { fontSize: '20px' },
  logoText: { fontSize: '18px', color: '#fff', fontWeight: '400' },
  tagline: { fontSize: '13px', lineHeight: 1.6, maxWidth: '260px', color: '#64748b' },
  social: { display: 'flex', gap: '16px', marginTop: '4px' },
  socialLink: { fontSize: '12px', cursor: 'pointer', color: '#64748b', transition: 'color 0.15s' },
  col: { display: 'flex', flexDirection: 'column', gap: '10px' },
  colTitle: { fontSize: '13px', fontWeight: '600', color: '#e2e8f0', marginBottom: '4px' },
  footerLink: { fontSize: '13px', cursor: 'pointer', transition: 'color 0.15s', color: '#64748b' },
  bottom: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '28px',
    fontSize: '13px',
    color: '#475569',
    flexWrap: 'wrap',
    gap: '12px',
  },
  bottomLinks: { display: 'flex', gap: '24px' },
  bottomLink: { cursor: 'pointer' },
};
